import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const addManegerDetailsAction = createAsyncThunk(
    'set-manager-detail-to-publisher',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/support-server/api/set-manager-detail-to-publisher`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const addManegerDetailsSlice = createSlice({
    name: 'set-manager-detail-to-publisher',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(addManegerDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(addManegerDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(addManegerDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const addManegerDetailsReducer = addManegerDetailsSlice.reducer